import React from 'react';

const NotAppliedContent = ({reportData, customMessage = null}) => {
    return (
        <>
            {!reportData && (
                <div id="notAppliedMessage" className={"alert alert-info p-2 h6 text-center"}>
                    {customMessage ? customMessage : "Aplique os filtros para exibir o relatório."}
                </div>
            )}
        </>
    );
};

export default NotAppliedContent;